export interface Videos {
    id: number;
    name: string;
    price: number;
    description: string;
    url: string;
    source: string;
  }
  
  export const videos = [
    {
      id: 1,
      name: 'Blindfold',
      price: 799,
      description: 'The music video stars Lil Jmoe, EHuncho and Moose Duce 2, shot and edited by me. The video shows a story of their life within Chicago.',
      url: 'https://www.youtube.com/embed/9tiZQMT22Po',
      source: 'https://www.youtube.com/watch?v=9tiZQMT22Po&list=RD9tiZQMT22Po&start_radio=1'
    },
    {
      id: 2,
      name: 'Fast Life',
      price: 699,
      description: 'A video I directed, and edited for a short street racing film called "Fast life". This video gained a lot of traffic with 100k views via instagram.',
      url: 'https://www.youtube.com/embed/9mFQ2BDBHHE',
      source: 'https://www.youtube.com/watch?v=9mFQ2BDBHHE'
    },
    {
      id: 3,
      name: 'SCM',
      price: 299,
      description: 'A video, shot, and edited by me, showcasing an independant wrestling company called SCM. This is a trailer to build hype of SCM while displaying their overall branding.',
      url: 'https://www.youtube.com/embed/2accDs0vu-0',
      source: 'https://www.youtube.com/watch?v=2accDs0vu-0&t=41s'
    },
    {
      id: 4,
      name: 'SCM Ad',
      price: 231,
      description: 'I directed and edited the SCM video ad. The cinematic ad showcases a wreslter, advertising his break in the SCM wrestling brand.',
      url: 'https://www.youtube.com/embed/W4WNL9sXj_E',
      source: 'https://www.youtube.com/watch?v=W4WNL9sXj_E&t=17s'
    }
  ];
  
  
  /*
  Copyright Google LLC. All Rights Reserved.
  Use of this source code is governed by an MIT-style license that
  can be found in the LICENSE file at https://angular.io/license
  */